import React from "react";
import SchoolItemBase from "./SchoolItemBase";

const PersonelSchoolItem = ({ itemId, onClose, isNewItem, gotoItem, DeleteItem, UpdateItem, InsertItem }) => {
  return (
    <SchoolItemBase
      itemId={itemId}
      onClose={onClose}
      isNewItem={isNewItem}
      gotoItem={gotoItem}
      DeleteItem={DeleteItem}
      UpdateItem={UpdateItem}
      InsertItem={InsertItem}
    />
  );
};

export default PersonelSchoolItem;
